import LoadImportResultTable from './loads-import-result-table';

export default LoadImportResultTable;
